export default __webpack_public_path__ + "static/media/Button - Icon (1).7fd9ab79.svg";